 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"1649f50dd82ad7c0319d1ab483b6df794ab2507b","3":"dbe04b34d2aa1f5fb9ea15e57305a0849b547c8b","4":"0ebae88b9452c047c876be54355c504fd859fbfa","5":"87f1339553de22dfdf02efecc89c3192e7a9f535","6":"4a6405fb1e0312b50556e0c8ba55ce4c01be88d4","7":"9f266cbae56a62b1e74b012c0e6da38ed5c1c38c","8":"b5f86651182099da8926e4d999d4c26a4d65e3d3","9":"framework","12":"component---gatsby-theme-gaviscon-src-templates-article-listing-page-article-listing-page-tsx","13":"component---gatsby-theme-gaviscon-src-templates-article-page-article-page-tsx","14":"component---gatsby-theme-gaviscon-src-templates-discovery-page-discovery-page-tsx","15":"component---gatsby-theme-gaviscon-src-templates-home-page-home-page-tsx","16":"component---gatsby-theme-gaviscon-src-templates-lds-page-lds-page-tsx","17":"component---gatsby-theme-gaviscon-src-templates-plain-page-plain-page-tsx","18":"component---gatsby-theme-gaviscon-src-templates-product-listing-page-product-listing-page-tsx","19":"component---gatsby-theme-gaviscon-src-templates-product-page-product-page-tsx","20":"component---gatsby-theme-gaviscon-src-templates-quiz-page-quiz-page-tsx","21":"component---gatsby-theme-gaviscon-src-templates-search-result-page-search-result-page-tsx","22":"component---gatsby-theme-gaviscon-src-templates-six-symptoms-page-six-symptoms-page-tsx","23":"component---gatsby-theme-gaviscon-src-templates-symptom-page-symptom-page-tsx","24":"component---src-gatsby-theme-gaviscon-pages-404-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"7fdb718215237e744851","2":"68871db7b43ae8f6c076","3":"62eaf0efe48a0bf20715","4":"b3ca67be960fd76e1438","5":"e04240e83a5ec4a0021c","6":"868efe59e9729862f99e","7":"349721de2e4b6dec48c4","8":"8be6f1b751664500bac5","9":"e4577eb79368f03609f3","12":"2f48be854634ed5a0ced","13":"2333a0d5899f75cea714","14":"6429b8a770064ebb11c7","15":"29c9c7a23ae90946f727","16":"92f38a91b41035d181fd","17":"edf8e6f3d8fbc96b8af4","18":"817c0980b8f76b1d83ae","19":"d9d9117c6912929ec28b","20":"d99c1f3f32e29fce0339","21":"adf36b21de138d04a731","22":"c765f37a4d318af9d3fe","23":"d453a6884e737b0802e2","24":"759fa115bbcb589b2eb2","26":"12f2727860ee30ba747c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"1649f50dd82ad7c0319d1ab483b6df794ab2507b","3":"dbe04b34d2aa1f5fb9ea15e57305a0849b547c8b","4":"0ebae88b9452c047c876be54355c504fd859fbfa","5":"87f1339553de22dfdf02efecc89c3192e7a9f535","6":"4a6405fb1e0312b50556e0c8ba55ce4c01be88d4","7":"9f266cbae56a62b1e74b012c0e6da38ed5c1c38c","8":"b5f86651182099da8926e4d999d4c26a4d65e3d3","9":"framework","12":"component---gatsby-theme-gaviscon-src-templates-article-listing-page-article-listing-page-tsx","13":"component---gatsby-theme-gaviscon-src-templates-article-page-article-page-tsx","14":"component---gatsby-theme-gaviscon-src-templates-discovery-page-discovery-page-tsx","15":"component---gatsby-theme-gaviscon-src-templates-home-page-home-page-tsx","16":"component---gatsby-theme-gaviscon-src-templates-lds-page-lds-page-tsx","17":"component---gatsby-theme-gaviscon-src-templates-plain-page-plain-page-tsx","18":"component---gatsby-theme-gaviscon-src-templates-product-listing-page-product-listing-page-tsx","19":"component---gatsby-theme-gaviscon-src-templates-product-page-product-page-tsx","20":"component---gatsby-theme-gaviscon-src-templates-quiz-page-quiz-page-tsx","21":"component---gatsby-theme-gaviscon-src-templates-search-result-page-search-result-page-tsx","22":"component---gatsby-theme-gaviscon-src-templates-six-symptoms-page-six-symptoms-page-tsx","23":"component---gatsby-theme-gaviscon-src-templates-symptom-page-symptom-page-tsx","24":"component---src-gatsby-theme-gaviscon-pages-404-tsx"}[chunkId]||chunkId) + "." + {"0":"a7287a40db9a16b20978","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
